import { onCLS, onINP, onLCP } from 'web-vitals';

import type { Attributes, Meter } from '@opentelemetry/api';

/**
 * Registers Core Web Vitals collection against the given meter. LCP, INP and
 * CLS are all recorded as histograms so their distributions survive
 * aggregation. CLS is reported once at finalization (page hide), matching
 * web-vitals' default lifecycle.
 *
 * @param meter OTel meter used to create the instruments.
 * @param getAttributes Optional supplier of attributes (e.g. the current
 *   route) read lazily at record time so each metric is dimensioned correctly.
 */
export function observeWebVitals(
  meter: Pick<Meter, 'createHistogram'>,
  getAttributes: () => Attributes = () => ({}),
): void {
  const lcpHistogram = meter.createHistogram('browser.lcp', {
    description: 'Largest Contentful Paint',
    unit: 'ms',
  });

  const inpHistogram = meter.createHistogram('browser.inp', {
    description: 'Interaction to Next Paint',
    unit: 'ms',
  });

  const clsHistogram = meter.createHistogram('browser.cls', {
    description: 'Cumulative Layout Shift',
    unit: 'score',
  });

  onLCP((metric) => lcpHistogram.record(metric.value, getAttributes()));
  onINP((metric) => inpHistogram.record(metric.value, getAttributes()));
  onCLS((metric) => clsHistogram.record(metric.value, getAttributes()));
}
